//@flow

import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import type { MapStateToProps } from 'react-redux';
import styled from 'styled-components';
import FlightCreator from './FlightCreator';
import WKT from 'ol/format/wkt';
import OlExtent from 'ol/extent';
import { getFlights, getProducts, setChosenFlight } from './../../../actions/flightManager';
import { getFaults, getFaultTagsDictionary } from './../../../actions/faults';
import { getComments } from './../../../actions/comments';
import AttributesContainer from './AttributesContainer';
import { flightStatusDictionary } from './../../../utilities/flightDictionaries';
import dropDownIcon from './../../../icons/dropdown.svg';
import AttachmentIcon from './../../../icons/clip.svg';
import PhotoIcon from './../../../icons/image.svg';
import VideoIcon from './../../../icons/video.svg';
import MapIcon from './../../../icons/layer.svg';
import ModelIcon from './../../../icons/3d.svg';
import DefaultButton from './../../../components/DefaultButton';
import GhostButton from './../../../components/GhostButton';
import ListRow from './../../../components/ListRow';
import ReactSVG from 'react-svg';
import IconCancel from './../../../icons/cancel.svg';
import { translate } from "react-i18next";
import TextInput from './../../../components/TextInput';
import Spinner from './../../../components/Spinner';
import _ from 'lodash';
import { getPhotos } from '../../../actions/photos';
import { loadVideosDetails } from '../../../actions/video';
import {
    centerMap, setEditMode, getLayersConfig
} from './../../../actions/map';
import BadgeIcon from '../../../components/BadgeIcon';

const StyledWrapper = styled.div`
    overflow: auto;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
`;

const FlightNumber = styled.span`
    color:  #2d2d2d;
    font-size: 14px;
    font-weight: 600;
    text-align: left;   
    max-width: 75%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const FlightStatus = styled.span`
    display: ${props => props.visible === false ? 'none' : 'block'};
    color:  #265a9c;
    font-size: 14px;
    font-weight: 700;
`;

const SorterWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

class FlightManager extends React.Component {
    constructor() {
        super();
        this.state = {
            displayedFeatures: [],
            filterTerm: '',
            sortByOrderNumber: 0,
            sortByStatus: 0,
            flightCreatorVisible: false,
        }
    }

    handleMissionClick = (event) => {
        const { chosenFlight, setChosenFlight } = this.props;
        if (chosenFlight && chosenFlight.id === Number(event.target.value)) {            
            setChosenFlight(null);
        } else {
            const newChosenFlight = this.props.rawData.find(flight => {
                return flight.id === Number(event.target.value);
            });
            if (newChosenFlight) {                
                setChosenFlight(newChosenFlight);
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { getLayersConfig, axiosInstance, chosenFlight, getPhotos, loadVideosDetails } = this.props;
        if (!_.isEqual(prevProps.chosenFlight, chosenFlight)) {
            getLayersConfig(axiosInstance, chosenFlight ? chosenFlight.id : 0);
        }
        getPhotos(axiosInstance, chosenFlight ? chosenFlight.id : null);
        loadVideosDetails(axiosInstance, chosenFlight ? chosenFlight.id : null, 'missions');
    }


    render() {
        const { t, rawData, roles, chosenFlight, centerMap }: Props = this.props;
        const nameArrowRotate = this.state.sortByOrderNumber === 1 ? '180' : '0';
        const statusArrowRotate = this.state.sortByStatus === 1 ? '180' : '0';
        const { flightCreatorVisible } = this.state;

        return (
            <StyledWrapper>
                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                    }}>
                    <TextInput
                        style={{
                            width: 'calc(100% - 12px)',
                            margin: '5px',
                        }}
                        type="text"
                        placeholder={t('Search') + '...'}
                        value={this.state.filterTerm}
                        onChange={(event) =>
                            this.setState({
                                filterTerm: event.target.value
                            })
                        }
                    >
                    </TextInput>
                    <DefaultButton
                        style={{
                            position: 'absolute',
                            top: '9px',
                            right: '9px',
                        }}
                        visible={this.state.filterTerm !== ''}
                        title={t('Clear')}
                        onClick={() => {
                            this.setState({
                                filterTerm: ''
                            })
                        }}>
                        <ReactSVG
                            path={IconCancel}
                            style={{
                                fill: '#ffffff',
                                width: '20px',
                                height: '20px'
                            }}
                        />
                    </DefaultButton>
                </div>
                <SorterWrapper>
                    <GhostButton
                        style={{
                            width: 'calc(50% - 15px)',
                            padding: '0 5px',
                            marginLeft: '5px',
                            display: 'flex',
                            border: 'none',
                            boxShadow: 'none',
                            height: '25px',
                        }}
                        onClick={() => {
                            this.setState({
                                sortByOrderNumber: this.state.sortByOrderNumber === 0
                                    ? 1
                                    : -this.state.sortByOrderNumber,
                                sortByStatus: 0
                            })
                        }}
                    >
                        {t('Name')}
                        <ReactSVG
                            path={dropDownIcon}
                            style={{
                                fill: '#265a9c',
                                width: '20px',
                                height: '20px',
                                display: this.state.sortByOrderNumber === 0 ? 'none' : 'block',
                                transform: `rotate(${nameArrowRotate}deg)`,
                            }}
                        />
                    </GhostButton>
                    <GhostButton
                        style={{
                            width: 'calc(50% - 15px)',
                            marginRight: '20px',
                            padding: '0 10px',
                            display: 'flex',
                            border: 'none',
                            boxShadow: 'none',
                            height: '25px',
                            justifyContent: 'flex-end',
                        }}
                        onClick={() => {
                            this.setState({
                                sortByOrderNumber: 0,
                                sortByStatus: this.state.sortByStatus === 0
                                    ? 1
                                    : -this.state.sortByStatus,
                            })
                        }}
                    >
                        {t('Status')}
                        <ReactSVG
                            path={dropDownIcon}
                            style={{
                                fill: '#265a9c',
                                width: '20px',
                                height: '20px',
                                transform: `rotate(${statusArrowRotate}deg)`,
                                display: this.state.sortByStatus === 0 ? 'none' : 'block',
                            }}
                        />
                    </GhostButton>
                </SorterWrapper>
                {rawData === null
                    ? <Spinner />
                    : <StyledWrapper
                        style={{
                            borderTop: '1px solid rgba(128, 128, 128, 0.1)',
                        }}
                    >
                        {rawData
                            .filter(flight => {
                                if (flight.projectName)
                                    return flight.projectName.toUpperCase()
                                        .includes(this.state.filterTerm.toUpperCase());
                                else return flight;
                            })
                            .sort((flightA, flightB) => {
                                const { sortByOrderNumber, sortByStatus } = this.state;
                                if (sortByOrderNumber !== 0) {
                                    return sortByOrderNumber === 1
                                        ? flightA.projectName.localeCompare(flightB.projectName)
                                        : -flightA.projectName.localeCompare(flightB.projectName)
                                }
                                else {
                                    return sortByStatus === 1
                                        ? t(flightStatusDictionary[flightA.flightStatus]).localeCompare(t(flightStatusDictionary[flightB.flightStatus]))
                                        : -t(flightStatusDictionary[flightA.flightStatus]).localeCompare(t(flightStatusDictionary[flightB.flightStatus]))

                                }
                            })
                            .map((flight) => {
                                const attributesVisible = chosenFlight
                                    ? chosenFlight.id === flight.id
                                    : false;
                                return (
                                    <ListRow
                                        key={flight.id} >
                                        <input
                                            id={`flight_${String(flight.id)}_radio`}
                                            type="radio"
                                            name="flight"
                                            value={flight.id}
                                            checked={attributesVisible ? 'checked' : ''}
                                            readOnly
                                            onClick={this.handleMissionClick} />
                                        <label
                                            htmlFor={`flight_${String(flight.id)}_radio`}
                                            onClick={(e) => {
                                                if (flight.geomWkt) {
                                                    const format = new WKT();
                                                    const feature = format.readFeature(flight.geomWkt)
                                                    const extent = feature.getGeometry().getExtent();
                                                    const center = OlExtent.getCenter(extent);
                                                    centerMap(center);
                                                };
                                            }}>
                                            <div className='rowTitle' style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'unset'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between'
                                                }}>
                                                    <FlightNumber>
                                                        {flight.projectName}
                                                    </FlightNumber>
                                                    <FlightStatus visible={!attributesVisible}>
                                                        {t(flightStatusDictionary[flight.flightStatus])}
                                                    </FlightStatus>
                                                </div>
                                                <div style={{
                                                    display: 'flex',
                                                    marginTop: '6px'
                                                }}>
                                                    {flight.layersCount ? <BadgeIcon
                                                        path={MapIcon}
                                                        count={flight.layersCount} /> : null}
                                                    {flight.videosCount ? <BadgeIcon
                                                        path={VideoIcon}
                                                        count={flight.videosCount} /> : null}
                                                    {flight.photosCount ? <BadgeIcon
                                                        path={PhotoIcon}
                                                        count={flight.photosCount} /> : null}
                                                    {flight.modelsCount ? <BadgeIcon
                                                        path={ModelIcon}
                                                        count={flight.modelsCount} /> : null}
                                                    {flight.resourcesCount ? <BadgeIcon
                                                        path={AttachmentIcon}
                                                        count={flight.resourcesCount} /> : null}
                                                </div>
                                                <AttributesContainer
                                                    flight={flight}
                                                    visible={attributesVisible}
                                                    openSelf={() => { this.setState({ flightCreatorVisible: true }) }}
                                                />
                                            </div>
                                        </label>
                                    </ListRow>
                                )
                            })}

                        <DefaultButton
                            style={{
                                position: 'absolute',
                                right: '20px',
                                bottom: '9px',
                                height: '30px',
                                padding: '0 5px',
                            }}
                            disabled={roles === 'Regular'}
                            visible={!flightCreatorVisible}
                            title={t("Add mission")}
                            onClick={() => {
                                this.props.setChosenFlight(null);
                                this.props.setEditMode(true);
                                this.setState({ flightCreatorVisible: true });
                            }}>
                            {t('Add mission')}
                        </DefaultButton>
                        <FlightCreator
                            visible={flightCreatorVisible}
                            closeSelf={() => { this.setState({ flightCreatorVisible: false }) }}
                        >
                        </FlightCreator>
                    </StyledWrapper>
                }
            </StyledWrapper>
        );
    }
}

const mapStateToProps: MapStateToProps<*, *, *> = state => ({
    rawData: state.flightManager.get('rawData'),
    chosenFlight: state.flightManager.get('chosenFlight'),
    chosenProject: state.auth.get('chosenProject'),
    axiosInstance: state.auth.get('axiosInstance'),
    roles: state.auth.get('roles'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    getFaults,
    getFaultTagsDictionary,
    getComments,
    getFlights,
    getProducts,
    setChosenFlight,
    centerMap,
    setEditMode,
    getLayersConfig,
    getPhotos,
    loadVideosDetails,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(FlightManager));


// WEBPACK FOOTER //
// ./src/containers/content/flightManager/FlightManager.jsx